import { cn } from 'lib/helpers/utility';

const PayAchButton = ({ className = 'self-end', payrocId }) => {
  return (
    <div className={cn('payment-button-submit-wrapper flex w-full items-center', className)}>
      <div
        className={cn(
          'ach-submit payroc-ach-submit-button h-12 w-fit',
          payrocId && `payroc-submit-${payrocId}`
        )}
      />
    </div>
  );
};

export default PayAchButton;
